import {addEventListenerIfNotExists, getBaseUrl} from "./common";
import Form from "./form";
import Collapsable from "./collapsable";
import { initRegisterForm } from "./main";

export class RegisterForm {
    private form: HTMLFormElement;
    private collapsable: Collapsable;
    private static readonly fullRegistrationSwitchId = 'full-registration-switch';
    private static readonly fullRegistrationAreaId = 'full-registration';


    constructor(form: HTMLFormElement) {
        this.form = form;
        addEventListenerIfNotExists(this.form, 'submit', (evt) => this.processForm(evt));
        this.collapsable = new Collapsable(RegisterForm.fullRegistrationSwitchId, RegisterForm.fullRegistrationAreaId);
    }

    async processForm(event: Event): Promise<void> {
        event?.preventDefault();
        const url = `${getBaseUrl()}register/index`;
        const form = new Form(url, this.form, this.replaceComponentContent, this.onModelError);
        await form.process(event);
    }

    private onModelError(html: string): void {
        document.querySelector('[data-component="Register"]').innerHTML = html;

        const formToRefresh = document.querySelector('[data-component=Register] form') as HTMLFormElement;
        initRegisterForm();
    }

    private replaceComponentContent(html: string): void {
        document.querySelector('[data-component="Register"]').innerHTML = html;
    }
}
